import axios from '../../index'
import qs from 'qs'
/**
 * @description 加载商品分类选项
 * @author txw
 * @date 2019-05-30
 * @export
 *
 */
export function loadClassifyOptions () {
  return axios.post(`/purchase/init-condition`)
}
/**
 * @description 加载采购商品列表
 * @author txw
 * @date 2019-05-30
 * @export
 *
 */
export function loadProductList (params) {
  return axios.post(`/purchase/index`, qs.stringify(params))
}
/**
 * @description 商品加入购物车
 * @author txw
 * @date 2019-05-30
 * @export
 */
export function addCart (params) {
  return axios.post(`/purchase/add-cart`, qs.stringify(params))
}
/**
 * @description 采购历史商品
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function loadPurchaseHistoryList (params) {
  return axios.post(`/user/purchase-order`, qs.stringify(params))
}
/**
 * @description 采购历史商品
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function getPurchaseHistoryInfo (params) {
  return axios.post(`/user/order-details`, qs.stringify(params))
}
